// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import 'amfe-flexible/index.js'
import App from './App'
import router from './router'
import store from './store'//引入store
import './utils/mock'
/*todo axios 请求数据*/
import axios from './utils/axios.js'
// 将API方法绑定到全局
Vue.prototype.$axios = axios
//将接口api文件,挂载到Vue实例上面
import api from './utils/api'
Vue.prototype.api = api
//将转换时间的工具类,挂载到Vue实例上面
import formatTime from './utils/formatTime'
Vue.prototype.formatTime = formatTime

import { Toast } from 'vant'; 
import 'vant/lib/index.css';
Vue.prototype.$toast = Toast
import VueAweSomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAweSomeSwiper)

import './assets/reset.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
bld_VM=new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>',
  data: {
    keywords: "",
    description: ""
  },
  created() {
    this.getSEO();
  },
  methods:{
    getSEO(){
      this.$axios.post(this.api.about.intro,{},res =>{
        document
          .querySelector('meta[name="keywords"]')
          .setAttribute("content", res.data.seo_keyword);
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", res.data.seo_description);
      }); 
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js